import { Plane, Matrix4, Vector3 } from "three";
/**
 * Preso spunto da drag controls
 * */
export class DragUtility {
    _plane = new Plane();
    _offset = new Vector3();
    _intersection = new Vector3();
    _worldPosition = new Vector3();
    _inverseMatrix = new Matrix4();
    doDragging(raycaster, selectedObject, camera) {
        if (selectedObject) {
            this._plane.setFromNormalAndCoplanarPoint(camera.getWorldDirection(this._plane.normal), this._worldPosition.setFromMatrixPosition(selectedObject.matrixWorld)); //important make it always to avoid problem with camera rotation during obj dragging
            if (raycaster.ray.intersectPlane(this._plane, this._intersection)) {
                return this._intersection.sub(this._offset).applyMatrix4(this._inverseMatrix);
            }
        }
        return undefined;
    }
    startDragging(raycaster, selectedObject, camera) {
        this._plane.setFromNormalAndCoplanarPoint(camera.getWorldDirection(this._plane.normal), this._worldPosition.setFromMatrixPosition(selectedObject.matrixWorld));
        if (raycaster.ray.intersectPlane(this._plane, this._intersection)) {
            this._inverseMatrix.copy(selectedObject.parent.matrixWorld).invert();
            this._offset.copy(this._intersection).sub(this._worldPosition.setFromMatrixPosition(selectedObject.matrixWorld));
        }
    }
    stopDragging() {
        //for future updates
    }
}
//# sourceMappingURL=DragUtility.js.map